import React from 'react'
import ContentBox from 'components/ContentBox'

export default function PageSupplementary ({ children }) {
  return (
    <ContentBox
      style={{
        maxWidth: '100%'
      }}
    >
      {children}
    </ContentBox>
  )
}
